import { createFileRoute } from '@tanstack/react-router';

import { GerminationDetailPage } from '@/modules/germination-test/components/germination-detail-page';
import { germinationDetailSearchSchema } from '@/modules/germination-test/utils/germination-search';

function GerminationRoutePage() {
  const { id } = Route.useParams();
  const { setup, ...listSearch } = Route.useSearch();

  return <GerminationDetailPage id={id} listSearch={listSearch} setup={!!setup} testKind="GER" />;
}

export const Route = createFileRoute('/seeds/germination/$id')({
  validateSearch: germinationDetailSearchSchema,
  component: GerminationRoutePage,
});
